import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { environment } from '../../../../../environments/environment'
import { OriginModel } from './models/origin.model'
import { Observable } from 'rxjs/Observable'
import { BehaviorSubject } from 'rxjs/BehaviorSubject'
import { OriginResponseModel } from './models/origin.response.model'

@Injectable()
export class OriginService {
  private readonly url = environment.base_url + '/v1/support/user-origins'
  private filters: any

  origins: OriginModel[]
  origin: OriginModel

  onOriginChanged: BehaviorSubject<any> = new BehaviorSubject(undefined)
  onFilterChanged: BehaviorSubject<any> = new BehaviorSubject('')
  onOriginsChange: BehaviorSubject<any> = new BehaviorSubject(undefined)

  constructor(private http: HttpClient) {
    this.origins = []
    this.origin = undefined
    this.filters = {
      paginated: true,
    }
  }

  /**
   *
   * @returns {Observable<OriginResponseModel>}
   */
  public list(): Observable<OriginResponseModel> {
    return this.http
      .get<OriginResponseModel>(this.url, { params: this.filters })
      .do(data => this.onOriginsChange.next(data))
  }
  /**
   *
   * @param {string} search
   */
  changeSearch(search: string) {
    this.filters.search = search
    this.onFilterChanged.next(this.filters)
  }

  /**
   * Update a Origin
   * @param {OriginModel} origin
   * @returns {Observable<OriginModel>}
   */
  public add(origin: OriginModel): Observable<OriginModel> {
    return this.http.post<OriginModel>(`${this.url}`, origin)
  }

  /**
   * Update a Origin
   * @param {OriginModel} origin
   * @returns {Observable<OriginModel>}
   */
  public update(origin: OriginModel): Observable<OriginModel> {
    return this.http.put<OriginModel>(`${this.url}/${origin.id}`, origin)
  }

  /**
   * Delete a Origin
   * @param {OriginModel} origin
   * @returns {Observable<OriginModel>}
   */
  public delete(origin: OriginModel): Observable<OriginModel> {
    return this.http.delete<OriginModel>(`${this.url}/${origin.id}`)
  }

  /**
   * setting the current administration
   * @param OriginModel
   */
  setOrigin(origin: OriginModel) {
    this.origin = origin
    this.onOriginChanged.next(origin)
  }
}



// WEBPACK FOOTER //
// ./src/app/main/content/system/origins/origin.service.ts